import { ApiRepresentation } from '../api-types/representation.api';
import { Representation } from '../app-types/representation.app';

export const transformApiRepresentationToAppRepresentation = (input: ApiRepresentation): Representation => {
	const firstName = input.firstName?.trim() ?? '';
	const lastName = input.lastName?.trim() ?? '';
	return {
		id: String(input.id),
		firstName,
		lastName,
		role: input.role?.trim() ?? '',
		service: input.service?.trim() ?? '',
		displayName: `${firstName} ${lastName}`.trim(),
		specialisation: input.specialisation?.trim() ?? '',
	};
};

export const transformApiRepresentationsToAppRepresentations = (input: ApiRepresentation[]): Representation[] => {
	return input.map(transformApiRepresentationToAppRepresentation);
};
